import { DetailedLabResultObservation } from '@pm/graphql';
import { InlineMessage } from '@pm/ui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { hasFlaggedObservations } from './utils';

export type ObservationWithDisplayName = DetailedLabResultObservation & {
  displayName: string;
};

type LabSummaryProps = {
  observations: ObservationWithDisplayName[];
  instructions: ReactNode;
  showTitle?: boolean;
};

export const LabSummary = ({
  observations,
  instructions,
  showTitle = true,
}: LabSummaryProps) => {
  const { t } = useTranslation('labs');

  if (!hasFlaggedObservations(observations) || !instructions) return null;

  return (
    <InlineMessage
      intent="info"
      size="small"
      showLeadingIcon={false}
      title={showTitle ? t('LabSummary.Title') : undefined}
      instructions={instructions}
    />
  );
};
